import { Creative } from 'types/creative'
import { formatBytes } from 'utils/formatBytes'

export const createCreativeDescription = (creative: Creative | null) => {
  const DESC_BY_CREATIVE_TYPE = {
    '0': `${creative?.width && creative?.height ? creative?.width + 'x' + creative?.height + ',' : ''} ${creative?.url
      ?.split('.')
      .pop()}, ${creative?.size ? formatBytes(creative?.size) : ''}`,
    '1': `${creative?.width && creative?.height ? creative?.width + 'x' + creative?.height + ',' : ''} ${creative?.url
      ?.split('.')
      .pop()}, ${creative?.size ? formatBytes(creative?.size) : ''}`,
    '2': 'Uncontrolled stream',
    '3': 'Controlled stream',
    '4': 'Youtube stream',
    '5': 'Twitch stream',
    '10': 'Roblox image',
    '11': 'Roblox video',
  }
  return (DESC_BY_CREATIVE_TYPE as any)[creative?.creative_type || 0]
}
